import Dropzone from "react-dropzone";
import {Box, styled, Typography} from "@mui/material";
import {UploadFileRounded} from "@mui/icons-material";

const UploadInput = (props) => {

    const {onChange, disabled, ...restProps} = props;
    const rootProps = (props) => !disabled ? props() : {}

    return (
        <Dropzone onDrop={acceptedFiles => onChange(acceptedFiles)}>
            {({getRootProps, getInputProps}) => (
                <Root {...rootProps(getRootProps)} {...restProps} className={disabled ? "Mui-disabled" : ""}>
                    <input type="file" multiple style={{ display: "none" }} {...getInputProps()}/>
                    <UploadFileRounded color="primary" sx={{fontSize: {xs: "3rem", lg: "3.5rem"} }}/>
                    <Typography mt={1} fontSize={{ xs: ".95rem", lg: ".975rem" }} textAlign="center">برای آپلود کلیک کنید یا فایل خود را در اینجا رها کنید</Typography>
                </Root>
            )}
        </Dropzone>
    )
}
export default UploadInput;

const Root = styled(Box)(({theme}) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    padding: 32,
    backgroundColor: theme.palette.grey.main,
    outline: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 16,
    cursor: "pointer",
    userSelect: "none",
    transition: "background-color .125s ease",
    "&.Mui-disabled": {
        filter: 'grayscale(1)',
        cursor: "not-allowed",
    },
    "&:not(.Mui-disabled):hover": {
        backgroundColor: theme.palette.grey.light
    }
}))
